export const requiredWhenSet = (key, passSchema) =>
  key ? passSchema.required("Required!") : passSchema;
